var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-main pcdetails"},[_c('el-backtop',{attrs:{"target":".pcdetails"}}),_c('div',{staticClass:"pchome-headerabo"},[_c('headers',{ref:"head",on:{"ChangeEmit":_vm.ChangeEmit}})],1),_c('position-bar',{attrs:{"productc_nav":_vm.productc_nav,"positionNav":_vm.positionNav}}),_c('specialEndo'),_c('footers',{ref:"is_change"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }